// src/app/layout/component/loading-overlay/loading-overlay.ts
// Minimal guard: ensure only one visible overlay (hides any extra instance on first load)

import { Component, ChangeDetectionStrategy, ChangeDetectorRef, DestroyRef, OnInit, OnDestroy, inject } from '@angular/core';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LoadingService } from '../../../core/shared/loading.service';

@Component({
    selector: 'app-loading-overlay',
    standalone: true,
    imports: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <div class="loading-overlay" [hidden]="!loading || !isPrimary">
            <div class="loading-backdrop"></div>
            <div class="loading-content">
                <img src="../assets/images/loading-gif1.webp" alt="Loading..." class="loading-image" />
                <div class="loading-text">{{ message }}</div>
            </div>
        </div>
    `
})
export class LoadingOverlayComponent implements OnInit, OnDestroy {
    private loader = inject(LoadingService);
    private cdr = inject(ChangeDetectorRef);
    private destroyRef = inject(DestroyRef);

    loading = false;
    message = 'Loading...';
    isPrimary = true;

    ngOnInit(): void {
        // Global flag: only the first mounted overlay is primary (visible)
        if (typeof window !== 'undefined') {
            const g = window as any;
            if (g.__appOverlayMounted) {
                this.isPrimary = false; // a primary overlay already exists → hide this instance
            } else {
                g.__appOverlayMounted = true; // claim primary
                this.isPrimary = true;
            }
        }

        this.loader.isLoading$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((v) => {
            this.loading = v;
            this.cdr.markForCheck();
        });

        this.loader.message$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((m) => {
            this.message = m;
            this.cdr.markForCheck();
        });
    }

    ngOnDestroy(): void {
        // Release the primary flag when this instance was the primary
        if (typeof window !== 'undefined' && this.isPrimary) {
            const g = window as any;
            g.__appOverlayMounted = false;
        }
    }
}
